import React, { useCallback, useEffect, useState } from "react";
import {
  Box,
  Card,
  Flex,
  NoData,
  Text,
  AvatarIcon,
  Pagination,
  Loader,
} from "atoms";
import Table from "molecules/Table";
import { usePropsoch } from "contexts/Propsoch";
import { useSort } from "hooks/useSort";
import { usePageNumber, usePageSize } from "hooks/usePageNumber";
import { format } from "date-fns";
import { PAGE_SIZE } from "utils/constants";

const columns = [
  {
    title: "Date and time",
    field: "date",
    sortKey: "createdAt",
    render: (row) => <>{row.date}</>,
  },
  {
    title: "User",
    field: "user",
    // sortKey: "user",
    render: (row) => (
      <Flex alignItems="center">
        <AvatarIcon
          height="2.4rem"
          width="2.4rem"
          fontSize="1.6rem"
          name={row.user}
        />
        <Text
          fontSize="1.6rem"
          color="neutral.500"
          fontFamily="NeometricRegular"
          pl=".5rem"
          whiteSpace="nowrap"
        >
          {row.user}
        </Text>
      </Flex>
    ),
  },
  {
    title: "Activity",
    field: "activity",
    sortKey: "activity",
    render: (row) => <Box maxWidth="30rem">{row.activity}</Box>,
  },

  // {
  //   title: "Action",
  //   rightAligned: true,
  //   render: () => (
  //     <Box color="neutral.900" cursor="pointer">
  //       <Link to="/setting/activity-log/user-activity">
  //         <MemoEyeShowIcon height="1.5rem" width="1.8rem" />
  //       </Link>
  //     </Box>
  //   ),
  // },
];
const ActivityLog = () => {
  // const [search, setSearch] = useState("");
  // const [filter, setFilter] = useState(false);
  // const [showFilter, setsSowFilter] = useState(false);
  // const [current, setCurrent] = useState(1);
  // const [data, setData] = useState([]);

  const {
    state: { users },
    actions: { getActivityLogs, getUsers },
  } = usePropsoch();

  // fields
  const [activityLogs, setActivityLogs] = useState([]);
  const [activityLogsLoading, setActivityLogsLoading] = useState(false);
  const [total, setTotal] = useState(0);
  const sort = useSort();
  const page = Number(usePageNumber());
  const pageSize = Number(usePageSize());

  // fetch property Listing
  const fetchPropertyListing = useCallback(() => {
    setActivityLogsLoading(true);
    getActivityLogs({
      sortBy: sort?.split(":")?.[0] || "createdAt",
      order: sort?.split(":")?.[1] || "desc",
      limit: pageSize,
      page: page,
    })
      .then((data) => {
        setActivityLogs(data?.rows);
        setTotal(data?.count);
      })
      .finally(() => {
        setActivityLogsLoading(false);
      });
  }, [getActivityLogs, page, pageSize, sort]);

  useEffect(() => {
    fetchPropertyListing();
    !users && getUsers();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fetchPropertyListing]);

  return (
    <Card my="2.4rem">
      {/* <Flex mb="2.4rem" alignItems="center">
        <SearchBox
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          onClose={() => setSearch("")}
          placeholder="Search"
          style={{ width: "30rem" }}
        />
        <Grid
          placeItems="center"
          height="4.8rem"
          width="6.8rem"
          borderRadius="1rem"
          border="1px solid"
          borderColor="primary.900"
          color="primary.900"
          ml="2.4rem"
          cursor="pointer"
          onClick={() => setsShowFilter(!showFilter)}
        >
          <MemoFilter height="1.8rem" width="1.8rem" />
        </Grid>
        {showFilter && (
          <Box position="absolute" zIndex={2} top="6rem">
            <ActivityFilter onClose={() => setsShowFilter(false)} />
          </Box>
        )}
        {filter && (
          <Text
            color="secondary.700"
            fontSize="1.6rem"
            fontFamily="NeometricBold"
            ml="2.4rem"
            cursor="pointer"
          >
            Clear All
          </Text>
        )}
      </Flex>
      {filter && (
        <Flex mb="2.4rem" gridGap="1rem">
          <ClosableChips name="Published" />
          <ClosableChips name="Published" />
        </Flex>
      )} */}
      <Loader loading={activityLogsLoading}>
        <Table
          tableHeader={columns.map(({ title, rightAligned, sortKey }) => ({
            name: title,
            rightAligned,
            sortKey,
            containerProps: {
              fontSize: "1.4rem",
              fontWeight: "600",
            },
          }))}
          borderColor="neutral.500"
        >
          {activityLogs.length > 0 && (
            <Box as="tbody" bg="white" verticalAlign="top">
              {activityLogs?.map((log, index) => (
                <tr key={index}>
                  <td>
                    {log?.createdAt &&
                      format(new Date(log?.createdAt), "dd MMM, yyyy/hh:mma")}
                  </td>
                  <td>
                    <Flex alignItems="center">
                      <AvatarIcon
                        height="2.4rem"
                        width="2.4rem"
                        fontSize="1.3rem"
                        name={
                          users?.find((i) => i?.id === log?.userId)?.name || ""
                        }
                      />
                      <Text
                        fontSize="1.6rem"
                        color="neutral.500"
                        fontFamily="NeometricRegular"
                        pl=".5rem"
                        whiteSpace="nowrap"
                      >
                        {users?.find((i) => i?.id === log?.userId)?.name || ""}
                      </Text>
                    </Flex>
                  </td>
                  <td>
                    <Box
                      maxWidth="30rem"
                      w="30rem"
                      // css={{
                      //   overflow: "hidden",
                      //   "text-overflow": "ellipsis",
                      //   "white-space": "nowrap",
                      // }}
                    >
                      {log?.message}
                    </Box>
                    {/* <Box class="ellipsis">
                    <Box class="content">
                      <Box class="text" w="30rem">
                        {log?.message}
                        {log?.message}
                        {log?.message}
                        <Box as="span" class="overlay">
                          <Box as="span" class="placeholder"></Box>
                          <Box as="span" class="more">
                            ...more
                          </Box>
                        </Box>
                      </Box>
                    </Box>
                  </Box> */}
                    {/* <div class="ellipsis">
                    <div class="content">
                      <div class="text">
                        text text text text text text text text text text text
                        text text text text text text text text text text{" "}
                      </div>
                      <div class="overlay">
                        <div class="placeholder"></div>
                        <div class="more">...more</div>
                      </div>
                    </div>
                  </div> */}
                  </td>
                </tr>
              ))}
            </Box>
          )}
        </Table>
        {activityLogs.length <= 0 && (
          <Box height="24rem" my="4.5rem">
            <NoData />
          </Box>
        )}
        {total > PAGE_SIZE && <Pagination totalRecords={total} showPageSize />}
      </Loader>
    </Card>
  );
};

export default ActivityLog;
